import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';
import { YearMonthDayString } from 'bloko/blocks/calendar/datesHelper';

export enum DateRange {
    LastWeek = 'lastWeek',
    LastTwoWeek = 'lastTwoWeek',
    LastMonth = 'lastMonth',
    LastQuarter = 'lastQuarter',
    All = 'all',
    None = 'none',
}

interface Interval {
    start: YearMonthDayString;
    end: YearMonthDayString;
}

interface VacancyConversionDateRanges {
    isMoreThanOneYear: boolean;
    selected: DateRange;
    ranges: Record<DateRange, Interval>;
}

const INITIAL_STATE = {
    isMoreThanOneYear: false,
    selected: DateRange.None,
    ranges: {},
} as VacancyConversionDateRanges;

const SET_SELECTED_RANGE = 'SET_SELECTED_RANGE';

interface PayloadTypes {
    [SET_SELECTED_RANGE]: DateRange;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setSelectedRange = actionCreator(SET_SELECTED_RANGE);

export default createReducer<VacancyConversionDateRanges, PayloadTypes>(INITIAL_STATE, {
    [SET_SELECTED_RANGE]: (state, { payload }) => ({
        ...state,
        selected: payload,
    }),
});
